module.exports = __webpack_public_path__ + "static/media/conditionArt.8fcc92f9.jpeg";